export default __webpack_public_path__ + "static/media/presentation-icon.db5c262a.png";